import React, { useState, useEffect, useRef } from 'react';
import Drawer from 'react-modern-drawer';
import 'react-modern-drawer/dist/index.css';
import { useForm } from 'react-hook-form';
// ✅ CHANGED: getCrops -> getCropShort
import { translateData, getLanguages, getCropShort } from '../lib/api';
import { Icon } from '@iconify/react/dist/iconify.js';
import { toast } from 'react-toastify';

const customStyles = `
  .form-grid-container {
    display: grid !important;
    grid-template-columns: 1fr 1fr !important;
    gap: 1.5rem !important;
    width: 100% !important;
    margin-bottom: 1.25rem !important;
  }
  .form-control, textarea {
    width: 100% !important;
    border-radius: 8px !important;
    padding: 8px 12px !important;
    border: 1px solid #ced4da !important;
    background: #fff !important;
  }
  .error-message { color: #dc3545; font-size: 0.75rem; }
  .success-message { color: #28a745; text-align: center; margin-bottom: 1rem; }

  .image-upload {
    border: 2px dashed #e2e8f0 !important;
    border-radius: 8px !important;
    padding: 1rem !important;
    text-align: center !important;
    background: #f8fafc !important;
    cursor: pointer !important;
  }

  /* Main Tabs (English / Other Languages) */
  .main-tabs { display: flex; gap: 8px; margin-bottom: 12px; }
  .main-tab {
    padding: 8px 14px;
    border: 1px solid #e5e7eb;
    background: #f9fafb;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 600;
  }
  .main-tab.active {
    background: #e8f0fe;
    border-color: #1a73e8;
    color: #1a73e8;
  }

  /* Language Sub-Tabs */
  .lang-tabs { display: flex; gap: 8px; flex-wrap: wrap; margin-bottom: 12px; }
  .lang-tab {
    padding: 6px 10px;
    border: 1px solid #e5e7eb;
    background: #f9fafb;
    border-radius: 6px;
    cursor: pointer;
    font-weight: 500;
  }
  .lang-tab.active {
    background: #e8f0fe;
    border-color: #1a73e8;
    color: #1a73e8;
  }

  /* Crop Checklist Styles */
  .crop-checklist-container {
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 1rem;
    background: #f8fafc;
    margin-bottom: 1.25rem;
  }

  .crop-checklist-title {
    font-weight: 600;
    margin-bottom: 12px;
    color: #374151;
    font-size: 0.875rem;
  }

  .crop-checklist-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 12px;
    max-height: 200px;
    overflow-y: auto;
    padding: 8px;
    background: white;
    border-radius: 6px;
    border: 1px solid #e5e7eb;
  }

  .crop-checkbox-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px;
    border-radius: 6px;
    transition: background-color 0.2s;
  }

  .crop-checkbox-item:hover {
    background: #f3f4f6;
  }

  .crop-checkbox {
    width: 16px;
    height: 16px;
    border-radius: 4px;
    border: 2px solid #d1d5db;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
  }

  .crop-checkbox.checked {
    background: #1a73e8;
    border-color: #1a73e8;
  }

  .crop-checkbox.checked::after {
    content: '✓';
    color: white;
    font-size: 12px;
    font-weight: bold;
  }

  .crop-label {
    font-size: 0.875rem;
    color: #374151;
    cursor: pointer;
    user-select: none;
  }

  .selected-crops-count {
    font-size: 0.75rem;
    color: #6b7280;
    margin-top: 8px;
  }
  .drawer-content-scroll {
    height: calc(100vh - 40px);
    overflow-y: auto !important;
    padding-right: 10px;
  }
  .card-body {
    overflow-y: auto !important;
    max-height: 100vh !important;
    padding: 1.5rem !important;
    overscroll-behavior: contain !important;
  }

  /* Other Images Grid */
  .other-images-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
    gap: 10px;
    margin-top: 10px;
  }
  .other-image-card {
    position: relative;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    padding: 4px;
    background: #fff;
  }
  .other-image-thumb {
    width: 100%;
    height: 70px;
    object-fit: cover;
    border-radius: 4px;
  }
  .remove-badge-btn {
    position: absolute;
    top: -6px;
    right: -6px;
    background: #ef4444;
    color: white;
    border: none;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 1px 3px rgba(0,0,0,0.2);
  }
`;

const safeParse = (val) => {
  if (!val) return [];
  if (Array.isArray(val)) return val;
  if (typeof val === 'string') {
    try {
      const parsed = JSON.parse(val);
      return Array.isArray(parsed) ? parsed : [val];
    } catch {
      return val.split(',').map((s) => s.trim()).filter(Boolean);
    }
  }
  return [];
};

const parseOtherLangField = (input, fieldKey) => {
  if (!input) return {};
  let parsed = input;

  if (typeof parsed === 'string') {
    try { parsed = JSON.parse(parsed); } catch { return {}; }
  }
  if (typeof parsed === 'string') {
    try { parsed = JSON.parse(parsed); } catch { return {}; }
  }

  return parsed[fieldKey] || {};
};

const isEnglishCode = (code) => String(code || '').toLowerCase() === 'en';

export default function AddPest({ isOpen, onClose, onSubmit, pestToEdit, isSubmitting = false }) {
  const [message, setMessage] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const saving = isSaving || isSubmitting;
  const [step, setStep] = useState('basic');
  const [mainTab, setMainTab] = useState('english');
  const [cropSearch, setCropSearch] = useState('');
  const [languages, setLanguages] = useState([]);
  const [selectedLang, setSelectedLang] = useState('');

  // Translations state — holds ONLY non-English entries
  const [translations, setTranslations] = useState({
    PestName: {},
    PestShortName: {},
    Description: {}
  });

  // Feature Image
  const [images, setImages] = useState([]);
  const [fileObjects, setFileObjects] = useState([]);

  // Additional Images (Up to 10)
  const [otherImageFiles, setOtherImageFiles] = useState([]);
  const [otherImagePreviews, setOtherImagePreviews] = useState([]);
  const [existingOtherImages, setExistingOtherImages] = useState([]);

  // Crops state
  const [crops, setCrops] = useState([]);
  const [selectedCropIds, setSelectedCropIds] = useState([]);

  const nameInputRef = useRef(null);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    getValues
  } = useForm({
    defaultValues: {
      name: pestToEdit?.name || pestToEdit?.PestName || '',
      shortName: pestToEdit?.shortName || pestToEdit?.PestShortName || '',
      description: pestToEdit?.description || pestToEdit?.Description || '',
      active: pestToEdit?.active !== undefined ? pestToEdit.active : (pestToEdit?.IsActive ?? true),
    },
  });

  const selectedLangName = languages.find(l => l.GoogleLanguageCode === selectedLang)?.LanguageName || selectedLang || '';

  // ✅ Non-English languages only (English handled in the English tab)
  const otherLanguages = languages.filter(l => !isEnglishCode(l.GoogleLanguageCode));

  // Keep selectedLang valid whenever languages change
  useEffect(() => {
    if (!otherLanguages.length) return;
    if (!otherLanguages.some(l => l.GoogleLanguageCode === selectedLang)) {
      setSelectedLang(otherLanguages[0].GoogleLanguageCode);
    }
  }, [languages]);

  // ✅ CHANGED: uses getCropShort instead of getCrops
  const loadCrops = async () => {
    try {
      // If your getCropShort wrapper already injects the token, just call: await getCropShort()
      // Otherwise, pass the token explicitly:
      const token =
        localStorage.getItem('token') ||
        localStorage.getItem('accessToken') ||
        localStorage.getItem('authToken');

      const cropsData = await getCropShort(token);
      // API returns { data: [...] }
      setCrops(cropsData?.data || cropsData || []);
    } catch (error) {
      console.error('Error loading crops:', error);
      setCrops([]);
    }
  };

  const filteredCrops = crops.filter(crop =>
    (crop.CropName || crop.Name || '')
      .toLowerCase()
      .includes(cropSearch.toLowerCase())
  );

  const prefillTranslationsFromEdit = () => {
    if (!pestToEdit || languages.length === 0) return;

    const tName = parseOtherLangField(pestToEdit.pestNameOtherLang || pestToEdit.PestNameOtherLang, 'PestName');
    const tShort = parseOtherLangField(pestToEdit.pestShortNameOtherLang || pestToEdit.PestShortNameOtherLang, 'PestShortName');
    const tDesc = parseOtherLangField(pestToEdit.descriptionOtherLang || pestToEdit.DescriptionOtherLang, 'Description');

    const next = { PestName: {}, PestShortName: {}, Description: {} };

    // ✅ Only non-English languages; English read from the form's English source fields
    otherLanguages.forEach(({ GoogleLanguageCode }) => {
      next.PestName[GoogleLanguageCode] = tName[GoogleLanguageCode] || '';
      next.PestShortName[GoogleLanguageCode] = tShort[GoogleLanguageCode] || '';
      next.Description[GoogleLanguageCode] = tDesc[GoogleLanguageCode] || '';
    });

    setTranslations(next);
  };

  const prefillSelectedCrops = () => {
    if (!pestToEdit?.CropIds) return;

    let cropIds = pestToEdit.CropIds;

    if (typeof cropIds === "string") {
      try {
        cropIds = JSON.parse(cropIds);
      } catch (error) {
        console.error("Invalid CropIds JSON:", cropIds);
        return;
      }
    }

    setSelectedCropIds(Array.isArray(cropIds) ? cropIds : [cropIds]);
  };

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);
  
  useEffect(() => {
    if (isOpen) {
      setTimeout(() => nameInputRef.current && nameInputRef.current.focus(), 100);
      loadCrops();
    }

    if (pestToEdit) {
      setValue('name', pestToEdit.name || pestToEdit.PestName || '');
      setValue('shortName', pestToEdit.shortName || pestToEdit.PestShortName || '');
      setValue('description', pestToEdit.description || pestToEdit.Description || '');
      setValue('active', pestToEdit.active !== undefined ? pestToEdit.active : (pestToEdit.IsActive ?? true));

      // Prefill Feature Image
      const loaded = [];
      const featureImg = pestToEdit.FeatureImage || (pestToEdit.images?.length > 0 ? pestToEdit.images[0] : null);
      if (featureImg) {
        loaded.push({
          id: `existing-${Date.now()}`,
          url: featureImg,
          name: 'Existing Image',
          isExisting: true
        });
      }
      setImages(loaded);
      setFileObjects([]);

      // Prefill Other Images
      const otherImgs = safeParse(pestToEdit.OtherImages || pestToEdit.otherImages);
      setExistingOtherImages(otherImgs);
      setOtherImageFiles([]);
      setOtherImagePreviews([]);

      // Prefill selected crops for edit mode
      prefillSelectedCrops();
    } else {
      reset({ name: '', shortName: '', description: '', active: true });
      setImages([]);
      setFileObjects([]);
      setExistingOtherImages([]);
      setOtherImageFiles([]);
      setOtherImagePreviews([]);
      setTranslations({ PestName: {}, PestShortName: {}, Description: {} });
      setSelectedCropIds([]);
    }

    setStep('basic');
    setMessage(null);
    setIsSaving(false);
    setMainTab('english');
    setSelectedLang('');

    if (isOpen) {
      getLanguages()
        .then(res => {
          const list = res?.data || res || [];
          setLanguages(list);
          // ✅ Default to first NON-English language
          const firstNonEn = list.find(l => !isEnglishCode(l.GoogleLanguageCode));
          if (firstNonEn) setSelectedLang(firstNonEn.GoogleLanguageCode);
          else if (list.length > 0) setSelectedLang(list[0].GoogleLanguageCode);
        })
        .catch(err => {
          console.error('Failed to load languages:', err);
          setLanguages([]);
          setSelectedLang('');
        });
    }
  }, [isOpen, pestToEdit]);

  useEffect(() => {
    if (pestToEdit && languages.length > 0) {
      prefillTranslationsFromEdit();
      if (!selectedLang && otherLanguages.length > 0) {
        setSelectedLang(otherLanguages[0].GoogleLanguageCode);
      }
    }
  }, [languages]);

  const handleCropToggle = (cropId) => {
    setSelectedCropIds(prev => {
      if (prev.includes(cropId)) {
        return prev.filter(id => id !== cropId);
      } else {
        return [...prev, cropId];
      }
    });
  };

  const handleSelectAllCrops = () => {
    if (selectedCropIds.length === crops.length) {
      setSelectedCropIds([]);
    } else {
      setSelectedCropIds(crops.map(crop => crop.ID));
    }
  };

  const callTranslateApi = async ({ PestName, PestShortName, Description }) => {
    try {
      const res = await translateData({
        PestName,
        PestShortName,
        Description
      });

      const maybeData = res?.data ?? res ?? {};
      const data = maybeData?.data && (maybeData.PestName === undefined)
        ? maybeData.data
        : maybeData;

      const normalized = { PestName: {}, PestShortName: {}, Description: {} };

      // ✅ Only non-English languages; English injected at save time from user's input
      otherLanguages.forEach(({ GoogleLanguageCode }) => {
        normalized.PestName[GoogleLanguageCode] =
          data.PestName?.[GoogleLanguageCode] || data.PestName?.en || PestName;

        normalized.PestShortName[GoogleLanguageCode] =
          data.PestShortName?.[GoogleLanguageCode] || data.PestShortName?.en || PestShortName;

        normalized.Description[GoogleLanguageCode] =
          data.Description?.[GoogleLanguageCode] || data.Description?.en || Description;
      });

      return normalized;
    } catch (err) {
      console.error('Translate API error: ', err);

      const fallback = { PestName: {}, PestShortName: {}, Description: {} };
      otherLanguages.forEach(({ GoogleLanguageCode }) => {
        fallback.PestName[GoogleLanguageCode] = PestName;
        fallback.PestShortName[GoogleLanguageCode] = PestShortName;
        fallback.Description[GoogleLanguageCode] = Description;
      });
      return fallback;
    }
  };

  const onInitialTranslate = async (data) => {
    if (!pestToEdit && fileObjects.length === 0) {
      setMessage({ type: 'error', text: 'Feature Image is required' });
      return;
    }

    if (languages.length === 0) {
      setMessage({ type: 'error', text: 'Languages not loaded yet. Please try again.' });
      return;
    }

    if (selectedCropIds.length === 0) {
      setMessage({ type: 'error', text: 'Please select at least one crop' });
      return;
    }

    const totalOtherImages = existingOtherImages.length + otherImageFiles.length;
    if (totalOtherImages > 10) {
      setMessage({ type: 'error', text: 'Maximum 10 additional images are allowed' });
      return;
    }

    setStep('translate');

    const translated = await callTranslateApi({
      PestName: data.name,
      PestShortName: data.shortName,
      Description: data.description
    });

    setTranslations(prev => ({
      PestName: { ...prev.PestName, ...translated.PestName },
      PestShortName: { ...prev.PestShortName, ...translated.PestShortName },
      Description: { ...prev.Description, ...translated.Description }
    }));

    setStep('translations');
    setMainTab('other');
  };

  /** -------- Step 2: Final Save -------- */
  const onFinalSave = async () => {
    if (saving) return;

    try {
      setIsSaving(true);
      setMessage(null);

      const name = getValues('name');
      const shortName = getValues('shortName');
      const description = getValues('description');
      const active = getValues('active');

      const payload = {
        PestName: name,
        PestShortName: shortName,
        Description: description,
        IsActive: active,
        CropIds: JSON.stringify(selectedCropIds),
        // ✅ English injected from user's input; other langs from translations state
        PestNameOtherLang: {
          PestName: { ...translations.PestName, en: name }
        },
        PestShortNameOtherLang: {
          PestShortName: { ...translations.PestShortName, en: shortName }
        },
        DescriptionOtherLang: {
          Description: { ...translations.Description, en: description }
        },
        OtherImages: otherImageFiles.length > 0 ? otherImageFiles : existingOtherImages,
        existingOtherImages: existingOtherImages,
        ...(pestToEdit && (pestToEdit.id || pestToEdit.ID) ? { ID: pestToEdit.id || pestToEdit.ID } : {})
      };

      await onSubmit(
        payload,
        !!pestToEdit,
        fileObjects[0] || null,
        otherImageFiles,
        existingOtherImages
      );

      const successText = pestToEdit ? 'Pest updated successfully!' : 'Pest added successfully!';
      setMessage({
        type: 'success',
        text: successText
      });
      toast.success(successText);

      setTimeout(() => {
        onClose();
        setMessage(null);
        setIsSaving(false);
      }, 1200);
    } catch (err) {
      console.error('Error saving pest:', err);
      const errorText = err?.response?.data?.message || err?.message || 'Failed to save pest. Please try again.';
      setMessage({
        type: 'error',
        text: errorText
      });
      toast.error(errorText);
      setIsSaving(false);
    }
  };

  /** -------- Feature Image upload logic -------- */
  const handleImageUpload = (event) => {
    const fileList = event.target.files || event.dataTransfer?.files || [];
    if (!fileList.length) return;

    const file = fileList[0];
    const imgObj = {
      id: Date.now(),
      file,
      url: URL.createObjectURL(file),
      name: file.name,
      size: file.size
    };

    setImages([imgObj]);
    setFileObjects([file]);
  };

  const handleRemoveImage = () => {
    setImages([]);
    setFileObjects([]);
  };

  /** -------- Other Images Upload (Up to 10) -------- */
  const handleOtherImagesUpload = (event) => {
    const files = Array.from(event.target.files);
    if (!files.length) return;

    const currentTotal = existingOtherImages.length + otherImageFiles.length;
    if (currentTotal + files.length > 10) {
      alert(`You can only upload up to 10 additional images. Currently you have ${currentTotal}.`);
      return;
    }

    const newPreviews = files.map((file) => ({
      id: `${Date.now()}-${Math.random()}`,
      file,
      url: URL.createObjectURL(file),
      name: file.name,
    }));

    setOtherImageFiles((prev) => [...prev, ...files]);
    setOtherImagePreviews((prev) => [...prev, ...newPreviews]);
  };

  const handleRemoveNewOtherImage = (index) => {
    setOtherImageFiles((prev) => prev.filter((_, i) => i !== index));
    setOtherImagePreviews((prev) => prev.filter((_, i) => i !== index));
  };

  const handleRemoveExistingOtherImage = (index) => {
    setExistingOtherImages((prev) => prev.filter((_, i) => i !== index));
  };

  /** -------- Validate Translations (non-English only) -------- */
  const isTranslationsValid = () => {
    return otherLanguages.every((lang) => {
      const code = lang.GoogleLanguageCode;
      return (
        translations.PestName[code]?.trim() &&
        translations.PestShortName[code]?.trim() &&
        translations.Description[code]?.trim()
      );
    });
  };

  const totalOtherImagesCount = existingOtherImages.length + otherImageFiles.length;

  return (
    <>
      <style>{customStyles}</style>

      <Drawer open={isOpen} direction="right" size={900}>
        <button
          variant="outline"
          onClick={onClose}
          disabled={saving}
          style={{ border: 'none', color: '#000', padding: 0, textAlign: 'end', padding: '15px', position: 'absolute', top: 0, right: 0, cursor: saving ? 'not-allowed' : 'pointer', opacity: saving ? 0.5 : 1 }}
        >
          <Icon icon="lucide:x" className="text-2xl" />
        </button>
        <div className="card-body drawer-content-scroll">
          <h6 className="text-xxl text-primary-light mb-16">
            {pestToEdit ? 'Edit Pest' : 'Add New Pest'}
          </h6>

          {message && (
            <div className={message.type === 'success' ? 'success-message' : 'error-message'}>
              {message.text}
            </div>
          )}

          {/* Main Tabs: English / Other Languages */}
          <div className="main-tabs">
            <button
              type="button"
              className={`main-tab ${mainTab === 'english' ? 'active' : ''}`}
              onClick={() => setMainTab('english')}
              disabled={saving}
            >
              English
            </button>
            <button
              type="button"
              className={`main-tab ${mainTab === 'other' ? 'active' : ''}`}
              onClick={() => setMainTab('other')}
              disabled={saving || (!pestToEdit && step !== 'translations')}
              title={!pestToEdit && step !== 'translations' ? 'Translate first to enable' : 'Other languages'}
            >
              Other Languages
            </button>
          </div>

          {/* Translating loader */}
          {step === 'translate' && (
            <div style={{ textAlign: 'center', padding: 40 }}>
              <h4>Translating…</h4>
              <p>Please wait...</p>
            </div>
          )}

          {/* ENGLISH TAB */}
          {mainTab === 'english' && step !== 'translate' && (
            <form onSubmit={handleSubmit(onInitialTranslate)}>
              {/* Name + Short Name */}
              <div className="form-grid-container">
                <div>
                  <label className="form-label">Pest Name *</label>
                  <input
                    className="form-control"
                    {...register('name', { required: 'Required', minLength: { value: 2, message: 'Min 2 chars' } })}
                    ref={(e) => {
                      register('name').ref(e);
                      nameInputRef.current = e;
                    }}
                  />
                  {errors.name && <span className="error-message">{errors.name.message}</span>}
                </div>

                <div>
                  <label className="form-label">Short Name *</label>
                  <input
                    className="form-control"
                    {...register('shortName', { required: 'Required', pattern: { value: /^[A-Za-z0-9]+$/, message: 'Only alphanumeric characters allowed' } })}
                  />
                  {errors.shortName && <span className="error-message">{errors.shortName.message}</span>}
                </div>
              </div>

              {/* Description */}
              <div className="mb-20">
                <label className="form-label">Description *</label>
                <textarea
                  className="form-control"
                  {...register('description', { required: 'Required', maxLength: { value: 500, message: 'Max 500 chars' } })}
                />
                {errors.description && <span className="error-message">{errors.description.message}</span>}
              </div>

              {/* Crop Checklist */}
              <div className="crop-checklist-container">
                <div className="crop-checklist-title"
                  style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>

                  <span>Select Crops *</span>

                  <button
                    type="button"
                    onClick={handleSelectAllCrops}
                    style={{
                      padding: '4px 8px',
                      fontSize: '0.75rem',
                      background: '#f3f4f6',
                      border: '1px solid #d1d5db',
                      borderRadius: '4px',
                      cursor: 'pointer'
                    }}
                  >
                    {selectedCropIds.length === crops.length ? 'Deselect All' : 'Select All'}
                  </button>
                </div>

                <input
                  type="text"
                  placeholder="Search crops..."
                  value={cropSearch}
                  onChange={(e) => setCropSearch(e.target.value)}
                  className="form-control"
                  style={{ marginBottom: '10px' }}
                />

                <div className="crop-checklist-grid">
                  {filteredCrops.map((crop) => (
                    <div key={crop.ID} className="crop-checkbox-item">
                      <div
                        className={`crop-checkbox ${selectedCropIds.includes(crop.ID) ? 'checked' : ''}`}
                        onClick={() => handleCropToggle(crop.ID)}
                      />
                      <label
                        className="crop-label"
                        onClick={() => handleCropToggle(crop.ID)}
                      >
                        {crop.CropName || crop.Name || `Crop ${crop.ID}`}
                      </label>
                    </div>
                  ))}
                </div>

                <div className="selected-crops-count">
                  {selectedCropIds.length} of {crops.length} crops selected
                </div>

                {selectedCropIds.length === 0 && (
                  <span className="error-message">Please select at least one crop</span>
                )}
              </div>

              {/* Feature Image + Status */}
              <div className="form-grid-container">
                <div>
                  <label className="form-label">
                    Feature Image {!pestToEdit && <span className="text-danger-600">*</span>}
                  </label>
                  <div className="image-upload" onClick={() => document.getElementById('imgInput')?.click()}>
                    <input
                      id="imgInput"
                      type="file"
                      accept="image/*"
                      onChange={handleImageUpload}
                      style={{ display: 'none' }}
                    />
                    {images.length === 0 ? 'Click to upload' : 'Click to change feature image'}
                  </div>

                  {images.length > 0 && (
                    <div style={{ marginTop: 10, display: 'flex', alignItems: 'center', gap: 8 }}>
                      <img
                        src={images[0].url?.startsWith('blob:') ? images[0].url : `https://api.soksan-dss.com/uploads/${images[0].url}`}
                        width={80}
                        height={80}
                        style={{ borderRadius: 6, objectFit: 'cover' }}
                        alt="feature"
                      />
                      <button type="button" className="remove-image-btn" onClick={handleRemoveImage}>×</button>
                    </div>
                  )}
                </div>

                <div>
                  <label className="form-label">Status</label>
                  <div className="form-check style-check d-flex align-items-center gap-8">
                    <input
                      className="form-check-input radius-4 border border-neutral-400"
                      type="checkbox"
                      {...register('active')}
                    />
                    <label className="form-label fw-medium text-primary-light text-sm mb-0">
                      Active
                    </label>
                  </div>
                </div>
              </div>

              {/* Additional Images (Up to 10) */}
              <div className="mb-20">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                  <label className="form-label mb-0">
                    Additional Images (Up to 10)
                  </label>
                  <span style={{ fontSize: '0.75rem', color: '#6b7280' }}>
                    {totalOtherImagesCount} / 10 selected
                  </span>
                </div>

                <div
                  className="image-upload"
                  onClick={() => {
                    if (totalOtherImagesCount < 10) {
                      document.getElementById('pestOtherImgsInput')?.click();
                    }
                  }}
                  style={{ opacity: totalOtherImagesCount >= 10 ? 0.6 : 1, cursor: totalOtherImagesCount >= 10 ? 'not-allowed' : 'pointer' }}
                >
                  <input
                    id="pestOtherImgsInput"
                    type="file"
                    accept="image/*"
                    multiple
                    disabled={totalOtherImagesCount >= 10}
                    onChange={handleOtherImagesUpload}
                    style={{ display: 'none' }}
                  />
                  {totalOtherImagesCount >= 10
                    ? 'Maximum 10 images reached'
                    : '+ Click to upload additional images (up to 10)'}
                </div>

                {/* Previews grid */}
                {(existingOtherImages.length > 0 || otherImagePreviews.length > 0) && (
                  <div className="other-images-grid">
                    {/* Existing Images */}
                    {existingOtherImages.map((imgName, idx) => (
                      <div key={`exist-${idx}`} className="other-image-card">
                        <img
                          src={`https://api.soksan-dss.com/uploads/${imgName}`}
                          className="other-image-thumb"
                          alt={`existing-${idx}`}
                        />
                        <button
                          type="button"
                          className="remove-badge-btn"
                          onClick={() => handleRemoveExistingOtherImage(idx)}
                          title="Remove image"
                        >
                          ×
                        </button>
                      </div>
                    ))}

                    {/* New Images */}
                    {otherImagePreviews.map((item, idx) => (
                      <div key={item.id} className="other-image-card">
                        <img
                          src={item.url}
                          className="other-image-thumb"
                          alt={`new-${idx}`}
                        />
                        <button
                          type="button"
                          className="remove-badge-btn"
                          onClick={() => handleRemoveNewOtherImage(idx)}
                          title="Remove image"
                        >
                          ×
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* Buttons */}
              <div className="d-flex justify-content-center gap-3">
                <button
                  type="button"
                  className="border border-danger-600 text-danger-600 px-56 py-10 radius-8"
                  onClick={onClose}
                  disabled={saving}
                  style={{ opacity: saving ? 0.6 : 1, cursor: saving ? 'not-allowed' : 'pointer' }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-yellow px-56 py-12"
                  disabled={saving || (!pestToEdit && images.length === 0) || selectedCropIds.length === 0 || totalOtherImagesCount > 10}
                  style={{
                    opacity: (saving || (!pestToEdit && images.length === 0) || selectedCropIds.length === 0 || totalOtherImagesCount > 10) ? 0.6 : 1,
                    cursor: (saving || (!pestToEdit && images.length === 0) || selectedCropIds.length === 0 || totalOtherImagesCount > 10) ? 'not-allowed' : 'pointer'
                  }}
                >
                  Translate
                </button>
                {pestToEdit && (
                  <button
                    type="button"
                    className="btn btn-yellow px-56 py-12"
                    onClick={onFinalSave}
                    disabled={saving || !isTranslationsValid() || selectedCropIds.length === 0}
                    style={{
                      opacity: (!isTranslationsValid() || saving || selectedCropIds.length === 0) ? 0.6 : 1,
                      cursor: (!isTranslationsValid() || saving || selectedCropIds.length === 0) ? 'not-allowed' : 'pointer'
                    }}
                  >
                    {saving ? (
                      <span className="d-flex align-items-center justify-content-center gap-2">
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                        <span>Updating...</span>
                      </span>
                    ) : (
                      'Update'
                    )}
                  </button>
                )}
              </div>
            </form>
          )}

          {/* OTHER LANGUAGES TAB */}
          {mainTab === 'other' && (
            <>
              {/* Language Sub-Tabs (English excluded) */}
              <div className="lang-tabs">
                {otherLanguages.length === 0 ? (
                  <span style={{ opacity: 0.7 }}>No other languages available</span>
                ) : (
                  otherLanguages.map((lang) => (
                    <button
                      key={lang.GoogleLanguageCode}
                      type="button"
                      className={`lang-tab ${selectedLang === lang.GoogleLanguageCode ? 'active' : ''}`}
                      onClick={() => setSelectedLang(lang.GoogleLanguageCode)}
                    >
                      {lang.LanguageName}
                    </button>
                  ))
                )}
              </div>

              {/* Translation Fields */}
              {selectedLang ? (
                <>
                  <div className="form-grid-container">
                    <div>
                      <label className="form-label">Pest Name ({selectedLangName})</label>
                      <input
                        className="form-control"
                        value={translations.PestName[selectedLang] || ''}
                        onChange={(e) =>
                          setTranslations((prev) => ({
                            ...prev,
                            PestName: { ...prev.PestName, [selectedLang]: e.target.value }
                          }))
                        }
                      />
                    </div>

                    <div>
                      <label className="form-label">Short Name ({selectedLangName})</label>
                      <input
                        className="form-control"
                        value={translations.PestShortName[selectedLang] || ''}
                        onChange={(e) =>
                          setTranslations((prev) => ({
                            ...prev,
                            PestShortName: { ...prev.PestShortName, [selectedLang]: e.target.value }
                          }))
                        }
                      />
                    </div>
                  </div>

                  <div className="mb-20">
                    <label className="form-label">Description ({selectedLangName})</label>
                    <textarea
                      className="form-control"
                      value={translations.Description[selectedLang] || ''}
                      onChange={(e) =>
                        setTranslations((prev) => ({
                          ...prev,
                          Description: { ...prev.Description, [selectedLang]: e.target.value }
                        }))
                      }
                    />
                  </div>
                </>
              ) : (
                <div style={{ opacity: 0.7, marginBottom: 12 }}>Select a language</div>
              )}

              {/* Buttons */}
              {message && (
                <div className={`mb-16 ${message.type === 'success' ? 'success-message' : 'error-message'}`}>
                  {message.text}
                </div>
              )}
              <div className="d-flex justify-content-center gap-3">
                <button
                  type="button"
                  className="border border-danger-600 text-danger-600 px-56 py-10 radius-8"
                  onClick={onClose}
                  disabled={saving}
                  style={{ opacity: saving ? 0.6 : 1, cursor: saving ? 'not-allowed' : 'pointer' }}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-yellow px-56 py-12"
                  onClick={onFinalSave}
                  disabled={saving || !isTranslationsValid()}
                  title={!isTranslationsValid() ? "Please fill all fields for all languages" : ""}
                  style={{
                    opacity: (!isTranslationsValid() || saving) ? 0.6 : 1,
                    cursor: (!isTranslationsValid() || saving) ? 'not-allowed' : 'pointer'
                  }}
                >
                  {saving ? (
                    <span className="d-flex align-items-center justify-content-center gap-2">
                      <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                      <span>{pestToEdit ? 'Updating...' : 'Saving...'}</span>
                    </span>
                  ) : (
                    pestToEdit ? 'Update' : 'Save'
                  )}
                </button>
              </div>
            </>
          )}
        </div>
      </Drawer>
    </>
  );
}